import styled, { css } from 'styled-components'
import { device } from 'components/Variable'
import { rem } from 'utils/common'

export const Bg = styled.div`
	padding: 0;
`
export const FormStyle = styled.form`
	padding: ${rem(40, 32)};
	position: sticky;
	top: ${rem(80)};
	z-index: 5;
	@media (${device.tablet}) {
		position: relative;
		top: 0;
		padding: ${rem(28, 20)};
	}
`
export const Description = styled.p`
	font-size: ${rem(14)};
	line-height: ${rem(20)};
	text-align: center;
	max-width: ${rem(370)};
	margin: 0 auto ${rem(15)};
`
export const LinkUnderline = styled.a`
	//font-weight: 600;
	font-size: ${rem(14)};
	line-height: ${rem(18)};
	display: inline-block;
	text-decoration: underline;
	cursor: pointer;
	transition: color 0.3s;
	&:hover {
		color: ${({ theme }) => theme.color.primary};
	}
	${(p) =>
		!p.orderNum &&
		p.orderLink &&
		css`
			margin-bottom: ${rem(30)};
		`}
`
